import React, { useEffect } from 'react';
import { Typography, Container, Paper, Grid, Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import LearnMoreSidebar from '../components/LearnMoreSidebar';

const LearnMore = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('LearnMore component rendered')
  }, [location]);

  return (
    <Box sx={{ display: 'flex', minHeight: 'calc(100vh - 64px)' }}>
      <Box component="nav" sx={{ width: 280, flexShrink: 0 }}>
        <Paper elevation={3} sx={{ height: '100%', overflowY: 'auto' }}>
          <LearnMoreSidebar />
        </Paper>
      </Box>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Container maxWidth="lg">
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
              Learn More
            </Typography>
            <Typography paragraph>
              Current path: {location.pathname}
            </Typography>
            <Outlet />
            {!location.pathname.split('/')[2] && (
              <Typography paragraph>
                Please select a topic from the sidebar to learn more.
              </Typography>
            )}
          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default LearnMore;
